/**
 * A LATHATO TERULET kovetese telefonon (versenyaudit K2).
 *
 * iOS-en a billentyuzet RAULIK az oldalra: a layout magassaga nem valtozik,
 * csak a lathato resz zsugorodik - igy a szerkeszto a billentyuzet moge
 * kerult, es a fejlec is elcsuszott. A `visualViewport` megmondja, mekkora
 * resz latszik valojaban; ezt adjuk at a CSS-nek (`--app-height`), es az
 * egesz alkalmazas ehhez igazodik. Androidon ugyanezt a viewport
 * `interactive-widget=resizes-content` beallitasa intezi, ott ez csak
 * megerosites.
 *
 * Nyitott billentyuzetnel (`data-keyboard`) a keret also biztonsagi savja
 * kikapcsol: azt a reszt a billentyuzet takarja, kulonben res maradna felette.
 */

/** Ennyi pixelnel nagyobb zsugorodas mar billentyuzet, nem bongeszo-sav. */
const KEYBOARD_THRESHOLD_PX = 120;

export function trackVisualViewport(): void {
  const viewport = window.visualViewport;
  if (!viewport) return;
  const root = document.documentElement;

  let frame = 0;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      root.style.setProperty('--app-height', `${Math.round(viewport.height)}px`);
      const keyboard = window.innerHeight - viewport.height > KEYBOARD_THRESHOLD_PX;
      if (keyboard) root.setAttribute('data-keyboard', '');
      else root.removeAttribute('data-keyboard');

      /*
        iOS a fokuszalt mezot "felgorgeti" a layout-viewporttal - a fejlec es
        az uzenetlista teteje ilyenkor kicsuszik a kepbol. Az alkalmazas sajat
        maga gorget, a dokumentumnak nem szabad.
      */
      if (document.scrollingElement && document.scrollingElement.scrollTop !== 0) {
        document.scrollingElement.scrollTop = 0;
      }
    });
  };

  viewport.addEventListener('resize', update);
  viewport.addEventListener('scroll', update);
  update();
}
